export default class Program {
  constructor(load = (computer) => { return {draw: () => {}, update: () => {}}; }) {
    this.load = load;
  }
}
